import type { BallProps } from './const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function Ball(props: BallProps, ref: React.Ref<HTMLDivElement>) {
  const { type = 'black', breath, className, style, ...rest } = props;

  return (
    <div ref={ref} className={cn('wg-ball-wrap', className)} style={style} {...rest}>
      <div
        className={cn('wg-ball', `wg-ball--${type}`, {
          'wg-ball--breath': breath,
        })}
      />
    </div>
  );
}

const BallComponent = forwardRef<HTMLDivElement, BallProps>(Ball);

BallComponent.displayName = 'Ball';

export default BallComponent;

export type { BallProps };
